export default __webpack_public_path__ + "static/media/cloud.3c0025fe.png";